import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';

var _templateObject;
var CheckboxButton = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: ", ";\n  height: 1rem;\n  left: 0;\n  position: absolute;\n  top: 0.6rem;\n  width: 1rem;\n  transform: translateY(-50%);\n"])), function (_ref) {
  var error = _ref.error,
    theme = _ref.theme;
  return !!error ? theme.palette.errorLightest : theme.palette.white;
}, function (_ref2) {
  var error = _ref2.error,
    _ref2$theme = _ref2.theme,
    border = _ref2$theme.border,
    palette = _ref2$theme.palette;
  return "".concat(border.size.small, " ").concat(border.style, " ").concat(!!error ? palette.error : palette.grayDark);
});
var CheckboxButton$1 = withDefaultTheme(/*#__PURE__*/memo(CheckboxButton));

export default CheckboxButton$1;
